module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pmenu"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "fechar",
    attrs: {
      "to": {
        name: 'leiloes.visualizar',
        params: {
          id: _vm.$route.params.id
        }
      }
    }
  }, [_vm._v("x")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', [_vm._v("Chat")])]), _vm._v(" "), _c('li', [_c('a', [_vm._v("Lances Automáticos")])]), _vm._v(" "), _c('li', [_c('a', [_vm._v("Consulta Rápida")])]), _vm._v(" "), _c('li', [_c('a', [_vm._v("Pausar Leilão")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26ef103a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/pregao/components/Menu.vue
// module id = 1568
// module chunks = 17